<i18n>
{
  "fr": {
    "submit": "Envoyer ma demande",
    "loading": "Demande en cours d'envoi...",
    "success": "Votre demande de devis a bien été envoyée !",
    "error": "Une erreur s'est produite, vérifiez que tous les champs requis soient bien remplis !"
  },
  "en": {
    "submit": "Submit my request",
    "loading": "Request being sent...",
    "success": "Your quote request has been successfully sent!",
    "error": "An error occurred, please ensure that all required fields are properly filled!"
  }
}
</i18n>

<template>
  <v-form
    ref="form"
    class="all-form-container"
    @submit.prevent="submit"
  >
    <div class="travel-container">
      <TravelSection
        ref="travelSectionRef"
        :form-not-validate="formNotValidate"
      />
    </div>
    <div class="car-container">
      <CarSection
        ref="carSectionRef"
        :form-not-validate="formNotValidate"
      />
    </div>
    <div class="travelers-container">
      <TravelersSection
        ref="travelersSectionRef"
        :form-not-validate="formNotValidate"
      />
    </div>
    <div class="buyer-information">
      <BuyerInformation
        ref="buyerSectionRef"
        :form-not-validate="formNotValidate"
      />
    </div>
    <p
      v-if="isSuccess === 1"
      class="successText"
    >
      {{ $t('success') }}
    </p>
    <p
      v-if="isSuccess === 84"
      class="notSuccessText"
    >
      {{ $t('error') }}
    </p>
    <div class="button-container">
      <v-btn
        type="submit"
        class="submit-button"
        :disabled="loading"
      >
        <div
          v-if="loading"
          class="loading-spinner"
        />
        <v-icon
          v-else-if="!loading"
          class="mr-1"
        >
          mdi-magnify
        </v-icon>
        {{ loading ? $t('loading') : $t('submit') }}
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import flightService from '@/services/flightService'
import BuyerInformation from './BuyerSection.vue'
import TravelersSection from './TravelersSection.vue'
import CarSection from './CarSection.vue'
import TravelSection from './TravelSection.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {
    BuyerInformation,
    TravelersSection,
    CarSection,
    TravelSection
  },
  data: () => ({
    formNotValidate: false,
    isSuccess: 0,
    loading: false
  }),
  computed: {
    ...mapGetters({
      customer: 'general/getCustomer'
    })
  },
  methods: {
    async submit () {
      if (this.$refs.form.validate() && this.$refs.travelSectionRef.validateTravelForm() !== 84) {
        this.loading = true
        const formatDate = moment()
        formatDate.locale('fr')
        const currentDateFormat = formatDate.format('DD/MM/YYYY')
        const travel = this.$refs.travelSectionRef.validateTravelForm()
        if (travel.cabins === '0' && travel.cabinsExt === '0' && travel.chairs === '0') {
          this.isSuccess = 84
          this.formNotValidate = true
          this.loading = false
          return
        }
        const vehicle = this.$refs.carSectionRef.validateCarSection()
        const travelers = this.$refs.travelersSectionRef.validateTravelersSection()
        const buyer = this.$refs.buyerSectionRef.validateBuyerForm()
        const nbVoyageurs = this.$refs.travelersSectionRef.validateNbTravelers()
        this.formNotValidate = false

        const formData = {
          proposal: {
            creationProposalDate: currentDateFormat,
            travelersNumber: nbVoyageurs
          },
          travel,
          vehicle,
          travelers,
          buyer
        }

        const jsonData = JSON.stringify(formData, null, 2)
        console.log(jsonData)
        await flightService.ferrySend(jsonData)
        this.isSuccess = 1
        this.$refs.form.reset()
        this.$nextTick(() => {
          this.$refs.travelersSectionRef.nbvoyageurs = 1
          this.$refs.travelersSectionRef.voyageurs = [{
            lastNameTraveler: '',
            firstNameTraveler: '',
            selectedBirstdayDay: null,
            selectedBirstdayMonth: null,
            selectedBirstdayYears: null
          }]
          this.$refs.buyerSectionRef.matricule = this.customer.registration_number
          this.$refs.buyerSectionRef.acheteurNom = this.customer.last_name
          this.$refs.buyerSectionRef.acheteurPrenom = this.customer.first_name
          this.$refs.buyerSectionRef.acheteurEmail = this.customer.email
          this.$refs.buyerSectionRef.telephonePortable = this.customer.phone_mobile
          this.loading = false
        })
      } else {
        this.isSuccess = 84
        this.formNotValidate = true
      }
    }
  }
}
</script>

<style scoped>
.all-form-container {
  background-color: white;
  padding: 25px;
  margin-bottom: 100px;
}

.car-container, .travelers-container, .buyer-information {
  /*padding-top: 25px;*/
}

.button-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 32px;
}

.successText {
  text-align: center;
  color: green;
  font-weight: bold;
  font-size: 18px;
}

.notSuccessText {
  text-align: center;
  color: red;
  font-weight: bold;
  font-size: 18px;
}

.submit-button {
  background-color: #EA4C89 !important;
  color: white;
  font-size: 18px;
  font-weight: bold;
  border-radius: 8px;
  transition: transform .2s;
  text-transform: uppercase;
  padding: 22px 45px !important;
}
.submit-button:hover {
  transform: scale(1.025);
}

.loading-spinner {
  margin-right: 10px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
